import type { ReactNode } from 'react';

export const symbol_sticker: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M458-360q64 0 114.5-36.5t67.13-96.59q2.37-5.91-2.32-10.41-4.68-4.5-10.31-2.5l-286 82q-7 1.91-8.5 9.07T336-403q26 22 57 32.5t65 10.5ZM279.27-516 390-550q2-27-17-46.5T326.53-616q-24.53 0-42.03 17.5T267-556q0 11 3 21t9.27 19ZM538-594l110-30q3-26-16-45.5T585.53-689q-24.53 0-42.03 17.5T526-629q0 9.58 3 18.29 3 8.71 9 16.71ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v434q0 12.44-5 23.72T822-303L657-138q-8 8-19.28 13-11.28 5-23.72 5H180Zm429-60v-83q0-35 26.5-61.5T697-351h83v-429H180v600h429Zm0 0Zm-429 0v-600 600Z"
		/>
	</svg>
);
